import { AnyObject, Maybe, Optional } from '@vimeo/core/types/generic';

import { ELiveErrorCode, IApiError } from '../../types/error';
import { LiveError } from './LiveError';

/**
 * @param error - target object to get name from
 * @returns error name from provided data structure
 */
export function getErrorName<T, E extends AnyObject>(error: Maybe<E>): T {
  return (error && error['name']) || null;
}

/**
 * @param error - target object to get error code from
 * @returns error code from provided data structure
 */
export function getErrorCode<T, E extends AnyObject>(error: Maybe<E>): T {
  return (error && error['code']) || null;
}

/**
 * @param error - target error instance to check
 * @returns whether provided error is API error in LiveError format
 */
export function isApiError(error: Optional<AnyObject>): error is LiveError<{ body: IApiError }> {
  return Boolean(
    error &&
      error instanceof LiveError &&
      error.code === ELiveErrorCode.API_ERROR &&
      error.data.body,
  );
}
